<script lang="ts" setup>
import { watchImmediate } from '@vueuse/core'
import gsap from 'gsap'

const headerRef = ref<HTMLElement>()
const $route = useRoute()
// let tl = gsap.timeline()
const appReady = useAppReady()
function enterHandel() {
  const point = headerRef.value?.querySelector('.point')
  gsap.to(point!, {
    svgOrigin: '141.1 21.485',
    rotation: -15,
    duration: 0.6,
    x: 2,
    y: -4,
    overwrite: true,
  })
}

function leaveHandel() {
  const point = headerRef.value?.querySelector('.point')
  gsap.to(point!, {
    rotation: 0,
    duration: 0.6,
    overwrite: true,
    x: 0,
    y: 0,
  })
}

function clickHandel(event: any) {
  event.preventDefault();
}
function isWindowBottom() {
  const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
  const { bottom, height ,y} = document.querySelector('#footer-logo')!.getBoundingClientRect()
  const b = document.documentElement.scrollHeight - (bottom + window.scrollY)
  return scrollTop + windowHeight >= documentHeight - (height + b);
}

function scrollHnadel() {
  if (isWindowBottom()) {
    headerRef.value?.classList.add('bot')
  } else {
    headerRef.value?.classList.remove('bot')
  }
}

onMounted(() => {
  watchImmediate(appReady, () => {
    if (appReady.value) {
      window.addEventListener('scroll', scrollHnadel);
    }
  })
})
</script>

<template>
  <div ref="headerRef" class="app-header" :class="{ ani: appReady }">
    <NuxtLink replace :href="$route.path === '/' ? '' : '/'" class="logo" @mouseenter="enterHandel"
      @mouseleave="leaveHandel" @click="clickHandel">
      <svg xmlns="http://www.w3.org/2000/svg" width="185" height="49" viewBox="0 0 185 49" fill="none">
        <g class="other">
          <path
            d="M93.6215 35.979L82.3585 22.273L93.6195 8.04102H88.4965L79.7965 19.096L71.0895 8.04102H65.9805L77.2425 22.264L65.9805 35.979H71.1035L79.8035 25.442L88.5105 35.979H93.6215Z"
            fill="white" />
          <path
            d="M0 22.272C0 12.69 5.989 7.00098 14.374 7.00098C22.459 7.00098 28.974 12.93 28.974 21.435C28.974 29.52 22.993 35.98 13.231 35.98H8.026L9.486 31.968H12.937C20.962 31.968 24.966 27.126 24.966 21.376C24.966 14.907 19.943 11.014 14.374 11.014C8.385 11.014 4.013 14.968 4.013 22.394V48.461H0V22.272Z"
            fill="white" />
          <path
            d="M61.969 35.978H57.955V22.392C57.955 14.966 53.584 11.013 47.595 11.013C42.025 11.013 37.003 14.906 37.003 21.374C37.003 27.124 41.003 31.967 49.032 31.967H53.943L52.49 35.978H48.733C38.971 35.978 32.99 29.518 32.99 21.433C32.99 12.929 39.51 7 47.59 7C55.974 7 61.964 12.69 61.964 22.272L61.969 35.978Z"
            fill="white" />
          <path
            d="M100.13 44.448H108.579C114.451 44.448 118.585 41.096 118.585 34.748V22.397C118.585 14.967 114.103 11.008 108.111 11.008C102.539 11.008 97.635 14.908 97.635 21.379C97.635 27.131 101.472 31.962 109.561 31.962H114.576L113.121 35.978H109.261C99.494 35.978 93.622 29.531 93.622 21.443C93.621 12.934 100.021 6.99701 108.171 6.99701C116.5 6.99701 122.6 12.69 122.6 22.276V34.744C122.6 43.433 116.668 48.46 108.639 48.46H101.509L100.13 44.448Z"
            fill="white" />
          <path
            d="M172.114 6.99701C179.453 6.99701 184.567 12.27 184.567 20.239V35.978H180.536V20.244C180.536 14.612 177.108 11.012 172.114 11.012C167.001 11.012 163.631 14.612 163.631 20.244V35.978H159.605V20.244C159.605 12.275 164.654 6.99701 172.114 6.99701Z"
            fill="white" />
        </g>
        <g class="red">
          <path
            d="M141.1 6.99701C138.235 6.99701 135.433 7.84672 133.051 9.43868C130.668 11.0306 128.811 13.2934 127.715 15.9407C126.618 18.588 126.331 21.5011 126.89 24.3115C127.449 27.1219 128.829 29.7034 130.855 31.7296C132.882 33.7558 135.463 35.1356 138.274 35.6946C141.084 36.2536 143.997 35.9667 146.644 34.8702C149.292 33.7736 151.554 31.9167 153.146 29.5341C154.738 27.1516 155.588 24.3505 155.588 21.485C155.588 17.6426 154.062 13.9575 151.345 11.2404C148.628 8.52342 144.942 6.99701 141.1 6.99701ZM141.1 31.963C139.028 31.963 137.002 31.3485 135.279 30.1971C133.556 29.0458 132.213 27.4094 131.42 25.4948C130.627 23.5802 130.419 21.4734 130.823 19.4409C131.228 17.4083 132.226 15.5413 133.691 14.0759C135.156 12.6106 137.023 11.6126 139.056 11.2083C141.088 10.804 143.195 11.0115 145.11 11.8046C147.024 12.5977 148.661 13.9406 149.812 15.6637C150.963 17.3868 151.578 19.4127 151.578 21.485C151.578 22.861 151.307 24.2235 150.78 25.4948C150.254 26.766 149.482 27.9211 148.509 28.8941C147.536 29.867 146.381 30.6388 145.11 31.1654C143.839 31.692 142.476 31.963 141.1 31.963Z"
            fill="#E71618" />
          <path class="point" d="M155.588 13.597V6.99701H148.988C151.775 8.51904 154.066 10.81 155.588 13.597Z"
            fill="#E71618" />
        </g>
      </svg>
    </NuxtLink>
    <div class="contact">
      <TextView path="/concat" :key="$route.path">
        <div class="btn-text">
          Contact
        </div>
        <template #icon>
          <div class="wrap-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"
              class="icon icon_show" alt="icon">
              <g clip-path="url(#clip0_1145_5528)">
                <path d="M0 9L17.4797 9" stroke="white" stroke-miterlimit="10" />
                <path d="M8.80078 0.322266L17.4768 9.00027L8.80078 17.6793" stroke="white" stroke-miterlimit="10" />
              </g>
              <defs>
                <clipPath id="clip0_1145_5528">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"
              class="icon icon_back" alt="icon">
              <g clip-path="url(#clip0_1145_5528)">
                <path d="M0 9L17.4797 9" stroke="white" stroke-miterlimit="10" />
                <path d="M8.80078 0.322266L17.4768 9.00027L8.80078 17.6793" stroke="white" stroke-miterlimit="10" />
              </g>
              <defs>
                <clipPath id="clip0_1145_5528">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </template>
      </TextView>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.lg {
  .app-header {
    width: 100%;
  }
}

.app-header {
  width: 100%;
  max-width: 1920px;
  height: 60px;
  position: fixed;
  top: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 210px;
  z-index: 12;
  pointer-events: none;
  transform: translateY(-200%);

  &.ani {
    animation: headerAni .8s .2s ease forwards;
  }


  &.bot {
    .other {
      opacity: 0;
    }

    .red {
      transform: translateX(-66%);
    }
  }


  @keyframes headerAni {
    from {
      transform: translateY(-200%)
    }

    to {
      transform: translateY(0%)
    }

  }

  .logo {
    width: 185px;
    pointer-events: all;

    svg {
      width: 100%;

      .other {
        transition: opacity .4s ease;
      }

      path {
        stroke: var(--fontColor) !important;
        fill: var(--fontColor) !important;
      }

      .red {
        transition: transform .5s ease;

        path {
          stroke: rgb(231, 22, 24) !important;
          fill: rgb(231, 22, 24) !important;
        }
      }
    }
  }

  .contact {
    width: 231px;
    height: 60px;
    border: 1px solid var(--headBtnBorderColor);
    border-radius: 50px;
    position: relative;
    pointer-events: all;
    transition: background-color .3s ease, border-color .3s ease;

    &:hover {
      background-color: var(--headBtnBgColor);
      border: 1px solid var(--headBtnBgColor);
    }

    .wrap-icon {
      margin-left: 13px;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;

      .icon {
        transition: transform 1.2s cubic-bezier(0.165, 0.84, 0.44, 1);
        stroke: var(--fontColor);

        path {
          stroke: var(--fontColor) !important;
        }
      }

      .icon_back {
        position: absolute;
        left: 0px;
        top: 0px;
        transform: translateX(calc(-100% - 5px));
      }
    }

    &:hover {
      .wrap-icon {
        .icon_show {
          transform: translateX(calc(100% + 5px));
        }

        .icon_back {
          transform: translateX(0%);
        }
      }
    }

    .icon {
      height: 18px;
    }
  }
}

.btn-text {
  font-size: 20px;
  font-weight: 300;
  color: var(--fontColor);
  text-shadow: 0px 1em 0px var(--fontColor);
  line-height: 1;
}

.xs {
  .app-header {
    padding: 0px 20px;
    top: 8px;

    .logo {
      width: 93px;
    }

    .contact {
      width: 110px;
      height: 41px;
      border-radius: 26px;

      .btn-text {
        font-size: 14px;
      }

      .wrap-icon {
        margin-left: 6px;

        .icon {
          height: 12px;
        }
      }
    }
  }
}
</style>
